import React, { useEffect, useState } from 'react';
import Navbar from '../global/Navbar';
import { CiSearch } from "react-icons/ci";
import BookCard from '../components/BookStore/BookCard';
import axios from 'axios';

const BookStore = () => {
  const [books, setBooks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true); // New loading state

  const fetchBooks = async () => {
    try {
      setLoading(true); // Start loading
      const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/books`);
      setBooks(response.data);
    } catch (error) {
      console.error("Failed to fetch books:", error.response?.data || error.message);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const filteredBooks = books.filter((book) =>
    book.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#101e2b]">
      <Navbar />
      <div className="container flex flex-col gap-4 px-4 lg:px-0">
        <div className="my-8">
          <div className="md:w-2/6 sm:w-3/6 w-5/6">
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex gap-2 items-center py-1 px-2 border border-[#00294B] bg-[#143E55] rounded-md focus-within:border-[#22BEFF]"
            >
              <input
                type="text"
                placeholder="Search.."
                className="w-full py-1 text-[#e6eaec] border-none outline-0"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <span className="text-[#e6eaec] cursor-pointer">
                <CiSearch />
              </span>
            </form>
          </div>
        </div>

        <div className="w-full grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-4 mb-[4rem] mt-[7rem]">
          {loading ? (
            <div className="col-span-full text-center text-white text-lg">
              Loading books...
            </div>
          ) : filteredBooks.length === 0 ? (
            <div className="col-span-full text-center text-white text-lg">
              No books found.
            </div>
          ) : (
            filteredBooks.map((book, index) => (
              <BookCard key={index} book={book} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default BookStore;
